module.exports = __webpack_public_path__ + "img/activity.b1836cc0.png";